/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { SiegeLieuSuiviFichierGridDto } from './SiegeLieuSuiviFichierGridDto';
import {
    SiegeLieuSuiviFichierGridDtoFromJSON,
    SiegeLieuSuiviFichierGridDtoFromJSONTyped,
    SiegeLieuSuiviFichierGridDtoToJSON,
} from './SiegeLieuSuiviFichierGridDto';

/**
 * 
 * @export
 * @interface SiegeLieuSuiviFichierGridDtoPaginatedResults
 */
export interface SiegeLieuSuiviFichierGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof SiegeLieuSuiviFichierGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<SiegeLieuSuiviFichierGridDto>}
     * @memberof SiegeLieuSuiviFichierGridDtoPaginatedResults
     */
    results?: Array<SiegeLieuSuiviFichierGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof SiegeLieuSuiviFichierGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the SiegeLieuSuiviFichierGridDtoPaginatedResults interface.
 */
export function instanceOfSiegeLieuSuiviFichierGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SiegeLieuSuiviFichierGridDtoPaginatedResultsFromJSON(json: any): SiegeLieuSuiviFichierGridDtoPaginatedResults {
    return SiegeLieuSuiviFichierGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function SiegeLieuSuiviFichierGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiegeLieuSuiviFichierGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(SiegeLieuSuiviFichierGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function SiegeLieuSuiviFichierGridDtoPaginatedResultsToJSON(value?: SiegeLieuSuiviFichierGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(SiegeLieuSuiviFichierGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

